export default "__VITE_ASSET__CPfYMsPF__"